import type { OmuiFileIconWithTooltipActionsComponent } from '../../../FileIconWithTooltipActions'

export const OmuiFileIconWithTooltipActions: OmuiFileIconWithTooltipActionsComponent = {
  styleOverrides: {
    root: ({ theme }) => ({
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: theme.palette.neutralLight[0],
      border: `1px solid ${theme.palette.neutralLight[300]}`,
      borderRadius: theme.spacing(2),
      boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.08)',
      minWidth: 280,
      maxWidth: 360,
      color: theme.palette.text.primary,
      textAlign: 'left',
      overflow: 'hidden',
    }),
    icon: {
      display: 'inline-flex',
      alignItems: 'center',
      cursor: 'default',
    },
    header: ({ theme }) => ({
      gap: theme.spacing(3),
      padding: theme.spacing(4),
    }),
    fileName: {
      wordBreak: 'break-word',
    },
    metadata: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    divider: {},
    actions: ({ theme }) => ({
      justifyContent: 'flex-end',
      gap: theme.spacing(4.5),
      padding: theme.spacing(4),
      '& .MuiButton-root': {
        textTransform: 'none',
      },
    }),
  },
}
